module.exports = __webpack_public_path__ + "img/bar.7c1c92c2.png";